import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import TaskStatusViewButton from './TaskStatusViewButton';

const TaskStatusViewButtonPicker = (props) => {
  const { pageContentResource } = usePageContentContext();

  return pickFunction(pageContentResource, {
    [fr.relationships.taskStatusView.name]: () => {
      return (
        <TaskStatusViewButton {...props} />
      );
    },
    [fr.relationships.default.name]: () => {
      return null;
    },
  });
};

export default TaskStatusViewButtonPicker;
